export default __webpack_public_path__ + "static/media/TURN.ccf652e0.mp3";